import { declareEvent } from "@cloudextend/common/events";

export const loggedOut = declareEvent("CEFI:Logout");